import { CyclathonDetails } from '../models/tournament.models';

/**
 * THE CYCLATHON'S DETAILS
 * ----------------------
 * When the ride starts, from where, over what. Settled once when the Habba is
 * planned and the same for every visitor, so it lives here next to the event
 * dates rather than in the database: changing it is a code edit, not a SQL
 * statement run by hand against two projects.
 *
 * The rider list is the opposite — the admin uploads it during the event — so
 * that stays in `cyclathon_riders` and is loaded as usual.
 *
 * The `cyclathon_event` table still exists and still holds a row. Nothing
 * reads it; these values are what the site shows.
 */
export const CYCLATHON_DETAILS: CyclathonDetails = {
  scheduledAt: '2026-09-27T06:30:00+05:30',
  venue: 'Flag-off: SB Temple',
  routeSummary: 'SB Temple → Government Museum → Buddha Vihar → Chandrashekhar Patil Stadium',
  distanceKm: 16,
};
